import request from 'axios'
import router from '@/router'
import Vue from 'vue'
const vm = Vue.prototype

request.defaults.headers.post['Content-Type'] = 'application/json'
request.defaults.headers.get['Content-Type'] = 'application/json'

// 请求拦截器
request.defaults.baseURL = process.env.VUE_APP_API_URL
request.interceptors.request.use(
    (config) => {
        config.data.source = 'Frscompania'
        config.data.platform = 'website'
        config.headers = {
            ...config.headers,
            source: 'Frscompania',
            platform: 'website',
            H5Authorization: sessionStorage.getItem('TranToken') || '',
            token: sessionStorage.getItem('TranToken') || '',
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// 响应拦截器

request.interceptors.response.use(
    (response) => {
        const { code, message } = response.data
        let errMessage = ''
        console.log(response)
        switch (code) {
            case 0:
                break;
            case 400114: // token fail
                errMessage = message
                sessionStorage.clear();
                break;
            default:
                errMessage = message
                break
        }
        if (errMessage) vm.$Message.error(errMessage)
        return response
    },
    (error) => {
        // Toast.fail('Error de red');
        return Promise.reject(error)
    },
)

// 导出实例

export default request
